// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const PayOutProviderIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "PayOutProvider/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M6 15.942c0 1.075.825 1.941 1.85 1.941h2.092c.891 0 1.616-.758 1.616-1.691 0-1.017-.441-1.375-1.1-1.609L7.1 13.417c-.658-.234-1.1-.592-1.1-1.609 0-.933.725-1.691 1.617-1.691h2.091c1.025 0 1.85.866 1.85 1.941M8.773 9v10M17 7.657l4.243-4.243v2.829M21.243 3.414h-2.829"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M15 4.594 12.5 5.78 9.583 4.594 6.667 5.78 2 4v19l4.083-1.781L9.583 23l2.917-1.781L16 23V11.5"
}));
export default PayOutProviderIcon;